import styled from "styled-components";

export const ProductInfos = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }

  figure {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 400px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    padding: 2px;
  }

  .rec.rec-arrow {
    background-color: #A9A9A9;
  }
  .rec.rec-dot {
    visibility: hidden;
  }
  .rec.rec-arrow:hover {
    background-color: #000000;
}
`;

export const FlagImage = styled.img`
  display: flex;
  justify-content: center;
  width: 15%;
  // height: auto;
  // margin-bottom: 20px;
  // z-index: 9999;
  // position: absolute;
`;

export const Relateds = styled.section`
  margin-top: 40px;

  & > div {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px 10px;

    @media (max-width: 599px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 400px) {
      grid-template-columns: 1fr;
    }
  }
`;

export const Price = styled.span`
  font-size: 1.7rem;
  color: #e69e00;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 1rem;
`;

export const Tax = styled.span`
  margin-left: 5px;
`;

export const Description = styled.p`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
`;

export const QuantitySelector = styled.input`
  border-radius: 5px;
  text-align: center;
  width: 70px;
  height: 41px;
  border: 1px solid #909090;
  margin-right: 12px;
`;

export const Thumbs = styled.div`
  display: grid;
  grid-gap: 6px;
  grid-template-columns: repeat(4, 1fr);

  figure {
    cursor: pointer;
  }
`;
export const CartIcon = styled.figure`
  border: none !important;
  margin-bottom: 0px !important;
  margin-right: 2px;
  svg {
    max-width: 20px;
  }

  `;

  export const SendForm = styled.figure`
    border: none !important;
    max-width: 20px !important;
    margin: 0px !important;
    margin-right: 5px !important;
  `;

export const FormAddProduct = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 30px 0px;
  border-top: 1px solid rgba(206, 204, 204, 0.4);
  `;

  export const FormRequestProduct = styled.form`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    align-items: center;
    justify-content: space-around;
    margin: 10px;
    border-top: 1px solid rgba(206, 204, 204, 0.4);
  `;

  export const FormQuoteShippingTax = styled.form`
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0px 0px 30px 0px;
  `;

  export const DivShippingTax = styled.div`
    padding: 30px 0px 0px 0px;
    border-top: 1px solid rgba(206, 204, 204, 0.4);
  `;

  export const DivDeliveryAt = styled.div`
    padding: 30px 0px 30px 0px;
    border-top: 1px solid rgba(206, 204, 204, 0.4);
  `;
  export const Originlabel = styled.div`
    padding: 30px 0px 30px 0px;
    display: flex;
    align-items: center;
    border-top: 1px solid rgba(206, 204, 204, 0.4);
  `;

  export const ZipSelector = styled.input`
  border-radius: 5px;
  text-align: center;
  width: 100%;
  height: 41px;
  border: 1px solid #909090;
  margin-right: 12px;
`;
  export const Input = styled.input`
  border-radius: 5px;
  text-align: center;
  width: 100%;
  height: 41px;
  margin-bottom: 10px;
  margin-top: 5px;
  border: 1px solid #909090;
`;
  export const InputSelect = styled.select`
  border-radius: 5px;
  text-align: center;
  width: 100%;
  height: 41px;
  margin-bottom: 10px;
  margin-top: 5px;
  border: 1px solid #909090;
`;


export const InputTextArea = styled.textarea`
border-radius: 5px;
text-align: center;
width: 100%;
height: 41px;
margin-bottom: 10px;
margin-top: 5px;
border: 1px solid #909090;
`;
export const DivSendForm = styled.div`
                display: grid;
                grid-template-columns: 20px 54px;
                justify-content: center;
                justify-items: center;
`;
export const DivFile = styled.div`
                display: grid;
                grid-template-columns: 0.5fr 1fr;
                justify-content: center;
                justify-items: center;
`;
